"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTableFieldContext = void 0;
const react_1 = require("react");
exports.RemoteTableFieldContext = (0, react_1.createContext)({});
//# sourceMappingURL=remote-table-field-context.js.map